import { IPSeparator, IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import CheckListProgress from 'components/Checklist/ChecklistProgress';
import {
  globalFontBoldWeight,
  globalStackItemStylesCard,
  globalStackStylesCard,
  globalStackTokensGapCard,
  globalStackTokensGapSmall,
  globalTextStylesCard,
} from 'globalStyles';
import { toLocaleDateShortNoYear } from 'utils/datetime';
import { getHtmlJSX } from 'utils/html';
import { ICardTaskProps } from './KanbanCard';

const KanbanCardTaskGeneric = (props: ICardTaskProps) => {
  //
  // Main render
  //
  return (
    <div
      onClick={() => {
        if (props.onClick) props.onClick(props.task);
      }}
    >
      <IPStack styles={globalStackStylesCard} tokens={globalStackTokensGapCard}>
        <IPStack.Item styles={globalStackItemStylesCard}>
          <IPText
            block
            styles={{
              root: { fontWeight: globalFontBoldWeight, paddingTop: 0, paddingBottom: 0, wordBreak: 'break-word' },
            }}
          >
            {props.task.name}
          </IPText>
        </IPStack.Item>
        {props.task.checkList.items.length > 0 && (
          <IPStack.Item>
            <CheckListProgress
              compact
              totalChecks={props.task.checkList.items.length}
              successChecks={props.task.checkList.getSuccessfulCount()}
              failedChecks={props.task.checkList.getFailedCount()}
            ></CheckListProgress>
          </IPStack.Item>
        )}
        {props.task.description && (
          <IPStack.Item styles={globalStackItemStylesCard}>
            <IPSeparator styles={{ root: { height: 1 } }}></IPSeparator>
            <IPText variant="small">{getHtmlJSX(props.task.description, true, true)}</IPText>
          </IPStack.Item>
        )}
        <IPStack.Item styles={globalStackItemStylesCard}>
          <IPSeparator styles={{ root: { height: 1 } }}></IPSeparator>
          <IPStack horizontal tokens={globalStackTokensGapSmall} verticalAlign="center">
            <IPStack.Item>
              <IPText block variant="small" styles={globalTextStylesCard}>
                {toLocaleDateShortNoYear(props.task.startDateTime)}
              </IPText>
            </IPStack.Item>
          </IPStack>
        </IPStack.Item>
      </IPStack>
    </div>
  );
};

export default KanbanCardTaskGeneric;
